// Client Configuration Mapping
// Each client has a unique ID and their own configuration

import log13 from '../components/enquiry/log13.png';

const clientConfigs = {
  // IIFD Surat - Default Client
  'iifd-surat': {
    clientId: 'iifd-surat',
    clientName: 'IIFD Surat',
    templateType: 'template7', // Specifies which form template to use
    isClient: true, // Set to true to show only after admin login
    instituteId: 106336, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: '989b4b56c7b5eae82687fb78c0d09d17ba2a2396200964c306cca453bbf2d100',
      areasApiAuth: 'MTQ3NTk0NXwwOjEyMzEyMzoxMDYyMTB8MzAwMDM=',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=11',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/{instituteId}?city_ids=210',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Gujarat',
        stateId: 5,
        city: 'Surat',
        defaultArea: 'Surat'
      }
    },
    contactInfo: {
      phone1: '9601336742',
      phone2: '7984434475',
      email: 'staffiifdsurat@gmail.com',
      website: 'iifdsurat.com',
      address: '3rd floor Riga street nr Rajhans Cosmic, G D Goenka road Vesu Canal road Surat'
    },
    branding: {
      logo: '/logo.webp',
      heroTitle: 'STUDENT REGISTRATION FORM',
      heroSubtitle: 'FASHION | INTERIOR | EVENT | SHORT TERM',
      badgeText: 'Premier Educational Institute',
      theme: {
        primaryColor: '#dc2626',
        secondaryColor: '#991b1b'
      }
    },
    stats: {
      alumni: '10000+',
      experience: '15+',
      placement: '100%',
      partners: '200+'
    },
    features: [
      'Industry-expert design faculty',
      '100% placement assistance',
      'Industry internships & projects',
      'Global design certifications'
    ],
    courses: [
    ]
  },

  // Demo Institute - Modern Template
  'demo-institute': {
    clientId: 'demo-institute',
    clientName: 'Demo Institute',
    templateType: 'template8',
    isClient: true, // Set to true to show only after admin login
    instituteId: 101985, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: 'your_auth_token_here',
      areasApiAuth: 'your_areas_auth_token_here',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Uttar Pradesh',
        stateId: 1,
        city: 'Basti',
        defaultArea: 'Hariay'
      }
    },
    contactInfo: {
      phone1: '1234567890',
      phone2: '0987654321',
      email: 'info@demoinstitute.com',
      website: 'demoinstitute.com',
      address: 'Demo Address, City, State'
    },
    branding: {
      logo: '/demo-logo.svg',
      heroTitle: 'ADMISSION FORM',
      heroSubtitle: 'Transform Your Future With Quality Education',
      badgeText: 'Top Ranked Institute',
      theme: {
        primaryColor: '#2563eb',
        secondaryColor: '#1e40af'
      }
    },
    stats: {
      alumni: '5000+',
      experience: '10+',
      placement: '95%',
      partners: '100+'
    },
    features: [
      'Expert Faculty',
      'Placement Support',
      'Industry Exposure',
      'Modern Infrastructure'
    ],
    courses: [
      'Diploma in Fashion Design',
      'Diploma in Interior Design',
      'Certificate Programs'
    ]
  },

  // Coaching Center Example
  'coaching-demo': {
    clientId: 'coaching-demo',
    clientName: 'Bright Future Coaching',
    templateType: 'template9',
    isClient: true, // Set to true to show only after admin login
    instituteId: 101985, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: 'your_auth_token_here',
      areasApiAuth: 'your_areas_auth_token_here',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Uttar Pradesh',
        stateId: 1,
        city: 'Basti',
        defaultArea: 'Hariay'
      }
    },
    contactInfo: {
      phone1: '9876543210',
      phone2: '9876543211',
      email: 'info@brightfuturecoaching.com',
      website: 'brightfuturecoaching.com',
      address: '123 Learning Street, Education Hub, Surat'
    },
    branding: {
      logo: '/coaching-logo.svg',
      heroTitle: 'Bright Future Coaching',
      heroSubtitle: 'Achieve Your Goals with Expert Guidance',
      badgeText: 'Top Rated Coaching Center',
      theme: {
        primaryColor: '#f5576c',
        secondaryColor: '#f093fb'
      }
    },
    stats: {
      alumni: '3000+',
      experience: '8+',
      placement: '98%',
      partners: '50+'
    },
    features: [
      'Small Batch Sizes',
      'Personalized Attention',
      'Regular Tests & Assessments',
      'Experienced Faculty',
      'Study Material Included'
    ],
    courses: [
      'JEE Mains & Advanced',
      'NEET Preparation',
      'Class 11-12 Science',
      'Class 11-12 Commerce',
      'Foundation Course (Class 8-10)',
      'Olympiad Preparation'
    ]
  },

  // College Example
  'college-demo': {
    clientId: 'college-demo',
    clientName: 'Excellence College of Arts & Science',
    templateType: 'template10',
    isClient: true, // Set to true to show only after admin login
    instituteId: 101985, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: 'your_auth_token_here',
      areasApiAuth: 'your_areas_auth_token_here',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Uttar Pradesh',
        stateId: 1,
        city: 'Basti',
        defaultArea: 'Hariay'
      }
    },
    contactInfo: {
      phone1: '9123456789',
      phone2: '9123456788',
      email: 'admissions@excellencecollege.edu',
      website: 'excellencecollege.edu',
      address: 'College Campus, University Road, Surat - 395007'
    },
    branding: {
      logo: '/college-logo.svg',
      heroTitle: 'Excellence College',
      heroSubtitle: 'Empowering Minds, Shaping Futures',
      badgeText: 'NAAC A+ Accredited',
      theme: {
        primaryColor: '#3b82f6',
        secondaryColor: '#1e3a8a'
      }
    },
    stats: {
      alumni: '8000+',
      experience: '12+',
      placement: '92%',
      partners: '150+'
    },
    features: [
      'State-of-the-art Infrastructure',
      'Experienced Faculty',
      'Industry Partnerships',
      'Research Opportunities',
      'Sports & Cultural Activities',
      'Scholarship Programs'
    ],
    courses: [
      'B.Sc. Computer Science',
      'B.Sc. Information Technology',
      'B.Com - Accounting & Finance',
      'B.Com - Banking & Insurance',
      'B.A. English Literature',
      'B.A. Psychology',
      'BBA - Business Administration',
      'BCA - Computer Applications'
    ]
  },

  // University Example
  'university-demo': {
    clientId: 'university-demo',
    clientName: 'National University of Advanced Studies',
    templateType: 'template11',
    isClient: true, // Set to true to show only after admin login
    instituteId: 101985, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: 'your_auth_token_here',
      areasApiAuth: 'your_areas_auth_token_here',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Uttar Pradesh',
        stateId: 1,
        city: 'Basti',
        defaultArea: 'Hariay'
      }
    },
    contactInfo: {
      phone1: '9988776655',
      phone2: '9988776656',
      email: 'admissions@nuas.edu.in',
      website: 'nuas.edu.in',
      address: 'University Campus, Knowledge Park, Surat - 395009, Gujarat, India'
    },
    branding: {
      logo: '/university-logo.svg',
      heroTitle: 'National University',
      heroSubtitle: 'Excellence in Education, Research & Innovation',
      badgeText: 'UGC Approved | NAAC A++ | NIRF Ranked',
      theme: {
        primaryColor: '#1a1f36',
        secondaryColor: '#c9a961'
      }
    },
    stats: {
      alumni: '25000+',
      experience: '25+',
      placement: '95%',
      partners: '500+'
    },
    features: [
      'World-class Faculty with PhD Qualifications',
      'International Collaborations & Exchange Programs',
      'Cutting-edge Research Facilities',
      'Industry-Integrated Curriculum',
      'Comprehensive Placement Support',
      'Entrepreneurship Development Cell',
      'State-of-the-art Libraries & Labs',
      'Residential Campus with Modern Amenities'
    ],
    courses: [
      'B.Tech - Computer Science & Engineering',
      'B.Tech - Mechanical Engineering',
      'B.Tech - Electronics & Communication',
      'B.Tech - Civil Engineering',
      'MBA - Marketing & Finance',
      'MBA - Human Resources',
      'M.Tech - Data Science',
      'M.Tech - Artificial Intelligence',
      'M.Sc. - Physics',
      'M.Sc. - Chemistry',
      'Ph.D. Programs (All Disciplines)',
      'Executive Education Programs'
    ]
  },

  // IIFD Surat Modern - App Style Template
  'iifd-surat-modern': {
    clientId: 'iifd-surat-modern',
    clientName: 'IIFD Surat',
    templateType: 'template12', // Modern app-style template
    isClient: true, // Set to false to show in public gallery
    instituteId: 106336,
    api: {
      baseUrl: 'https://api.proctur.com',
      authorization: '989b4b56c7b5eae82687fb78c0d09d17ba2a2396200964c306cca453bbf2d100',
      areasApiAuth: 'MTQ3NTk0NXwwOjEyMzEyMzoxMDYyMTB8MzAwMDM=',
      endpoints: {
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=5',
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/{instituteId}?city_ids=210',
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },
      defaults: {
        state: 'Gujarat',
        stateId: 5,
        city: 'Surat',
        defaultArea: 'Surat'
      }
    },
    contactInfo: {
      phone1: '9601336742',
      phone2: '7984434475',
      email: 'staffiifdsurat@gmail.com',
      website: 'iifdsurat.com',
      address: '3rd floor Riga street nr Rajhans Cosmic, G D Goenka road Vesu Canal road Surat'
    },
    branding: {
      logo: '/logo.webp',
      heroTitle: 'Welcome to IIFD Surat',
      heroSubtitle: 'Fashion | Interior | Event | Short Term Programs',
      badgeText: 'Premier Design Institute',
      theme: {
        primaryColor: '#dc2626',
        secondaryColor: '#991b1b'
      }
    },
    stats: {
      alumni: '10000+',
      experience: '15+ Years',
      placement: '100%',
      partners: '200+'
    },
    features: [
      'Industry-expert design faculty',
      '100% placement assistance',
      'Industry internships & projects',
      'Global design certifications',
      'Modern studio facilities',
      'Portfolio development support'
    ],
    courses: []
  },

  // IIFD Surat Clean - App Style Template (No Banner, Stats, Features)
  'prayaas-education': {
    clientId: 'PRAYAAS Education',
    clientName: 'PRAYAAS Education',
    templateType: 'template13', // Clean modern template
    isClient: true, // Set to false to show in public gallery
    instituteId: 106348,
    api: {
      baseUrl: 'https://api.proctur.com',
      authorization: '375638e1d7960d2a5fc52871a3ecbccad34427c19a99a123f8b87fbfd100ca68',
      areasApiAuth: 'MTQ3NTk0NXwwOjEyMzEyMzoxMDYyMTB8MzAwMDM=',
      endpoints: {
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=5',
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/{instituteId}?city_ids=210',
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },
      defaults: {
        state: 'Gujarat',
        stateId: 5,
        city: 'Surat',
        defaultArea: 'Surat'
      }
    },
    contactInfo: {
      phone1: '+91 7378743031',
      phone2: '+91 7767073031',
      email: 'prayaas.edu2024@gmail.com',
      website: '',
      address: '2nd Floor, Loan Center, Sterling Plaza, CTS No. 1262/B, Plot No. 594B Office No. 301A, 301, Jangali Maharaj Rd, above AXIS BANK, Pune, Maharashtra 411004'
    },
    branding: {
      logo: log13,
      heroTitle: 'Welcome to PRAYAAS Education',
      heroSubtitle: 'Dedicated to transforming education for holistic development',
      badgeText: 'Premier Education Institute',
      theme: {
        primaryColor: '#dc2626',
        secondaryColor: '#991b1b'
      }
    },
    stats: {
      alumni: '10000+',
      experience: '15+ Years',
      placement: '100%',
      partners: '200+'
    },
    features: [
      'Industry-expert design faculty',
      '100% placement assistance',
      'Industry internships & projects',
      'Global design certifications',
      'Modern studio facilities',
      'Portfolio development support'
    ],
    courses: []
  }
};

// Helper function to check if client ID is valid
export const isValidClientId = (clientId) => {
  return clientConfigs.hasOwnProperty(clientId);
};

// Helper function to get client config by ID
export const getClientConfig = (clientId) => {
  return clientConfigs[clientId] || null;
};

// Helper function to get all client IDs
export const getAllClientIds = () => {
  return Object.keys(clientConfigs);
};

// Helper function to build API URL
export const getApiUrl = (clientConfig, endpointKey) => {
  const baseUrl = clientConfig.api.baseUrl;
  const endpoint = clientConfig.api.endpoints[endpointKey];

  // Replace {instituteId} placeholder with actual instituteId
  const finalEndpoint = endpoint.replace('{instituteId}', clientConfig.instituteId);

  return `${baseUrl}${finalEndpoint}`;
};

export default clientConfigs;
